import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=bb98a8ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb98a8ce"]])

export default __exports__